/*
 * @Author: Yolo
 * @Date: 2024-03-26 11:45:29
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-06-07 17:23:00
 * @describe 属性展示
 */
import L from 'leaflet'
import { type MyMap, ShipxyAPI } from '@map-sdk/sdk/ShipxyAPISDK'

interface AttributionElaneOptions extends L.Control.AttributionOptions {
  emptyString?: string
}
class AttributionElane extends L.Control.Attribution {
  private _options: AttributionElaneOptions
  private _container!: HTMLElement
  constructor(options?: AttributionElaneOptions) {
    super(options)
    this._options = {
      position: 'bottomright',
      emptyString: 'shipxy ',
      prefix: '',
      ...options,
    }
    L.Util.setOptions(this, this._options)
  }

  private _onLayerChange(event: L.LayerEvent): void {
    const layer = event.layer
    if ((layer as any).getAttribution) {
      if (event.type === 'layeradd') {
        this.addAttribution((layer as any).getAttribution())
      } else if (event.type === 'layerremove') {
        this.removeAttribution((layer as any).getAttribution())
      }
    }
  }

  override onAdd(map: MyMap): HTMLElement {
    const vMaj = Number.parseInt(L.version.split('.')[0])
    if (vMaj >= 1) {
      // Leaflet 1
      map.attributionControl = this
    }

    if (this._options.emptyString && this._options.emptyString.length > 0)
      this.options.prefix = this._options.emptyString

    this._container = L.DomUtil.create('div', 'leaflet-control-attribution')
    if (L.DomEvent) {
      L.DomEvent.disableClickPropagation(this._container)
    }

    if (vMaj < 1) {
      // Leaflet sub 1
      map
        .on('layeradd', this._onLayerChange, this)
        .on('layerremove', this._onLayerChange, this)
    }
    map.eachLayer((layer) => {
      if (layer.getAttribution) {
        this.addAttribution((layer as any).getAttribution())
      }
    })
    ;(this as any)._update()
    L.DomUtil.addClass(this._container, 'leaflet-condensed-attribution')
    return this._container
  }
}

const attributionElane = (options?: AttributionElaneOptions) => {
  ShipxyAPI.Map.mergeOptions({
    attributionControl: false,
  })
  return new AttributionElane(options)
}

export default attributionElane
